import { Component } from 'react';
import { inject, observer } from 'mobx-react';
import propTypes from 'prop-types';

import { getBSLImageURL } from '../../../utils/utils';
import { DeleteIcon } from './DeleteIcon/DeleteIcon';
import { QtyControl } from './QtyControl/QtyControl';
import Subtotal from './PriceCell/Subtotal';
import { CallUs } from './PriceCell/CallUs';
import { CompareCheckbox } from './CompareCheckbox/CompareCheckbox';
import { DeliveryCell } from './DeliveryCell/DeliveryCell';
import { SubstitutionSectionWrapper } from './SubstitutionSection/SubstitutionSectionWrapper';
import { SubstitutionSectionHeader } from './SubstitutionSection/SubstitutionSectionHeader/SubstitutionSectionHeader';
import { ObsoletePriceMsg } from './PriceCell/ObsoletePriceMsg';
import { Badge } from './ProductCell/Badge';
import { WeeePrices } from '../WeeePrices/weee-prices';
import { CustomizationFields, shouldRenderCustomizationFields } from '../CustomizationFields';
import { PesEllipsis } from '@pes-ui/components-react';
import { createCardHtmlContent } from '../../../helpers/helpers';
class _SingleItemMobile extends Component {
  get hasPrice() {
    const { optionsStore, card } = this.props;

    return optionsStore.isPriceEnabledOnSite && !!card.price && !!card.currency;
  }

  get hasSubstitutions() {
    const { substRootStore, card } = this.props;

    return this.isShowSubstitutions && !!substRootStore.getSubstSectionStores(card);
  }

  get isShowSubstitutions() {
    const { optionsStore, substRootStore, card } = this.props;

    return card.isObsolete && !optionsStore.disableSubstitutions && !!substRootStore.substitutions;
  }

  renderIcons() {
    const { optionsStore, card, isEditable } = this.props;
    const isWeeePrices = Boolean(optionsStore.isWeeePricesVisible && card.weeePricesData);

    if (!isEditable && !isWeeePrices) {
      return null;
    }

    return (
      <div>
        {isEditable && (<DeleteIcon onClickHandler={card.remove} />)}
        {isWeeePrices && (
          <div className="my-card__weee-prices"><WeeePrices prices={card.weeePricesData} /></div>
        )}
      </div>
    );
  }

  renderFooter() {
    const { optionsStore, labelsStore, card, isEditable } = this.props;
    const showObsoletePriceMsg = optionsStore.isPriceEnabledOnSite && card.isObsolete;
    const shouldShowCall = optionsStore.isPriceEnabledOnSite && !showObsoletePriceMsg && !this.hasPrice;

    return (
      <div className="cart-table__row cart-table__row--top">
        <div className="cart-table__checkbox cart-table--indent ">
          <CompareCheckbox card={card} label={labelsStore.cardCompare} />
        </div>
        <div className="cart-table--top cart-table__column quantity">
          <QtyControl item={card} isEditable={isEditable} label={labelsStore.giftlistTableQty} />
          {shouldShowCall && <CallUs />}

          {card.isShowReplacingStatus && (
            <span className="my-cart__replacing-msg">{card.getReplacingQtyMsg()}</span>
          )}

          {this.isShowSubstitutions && !this.hasSubstitutions && (
            <SubstitutionSectionHeader parentSkuID={card.skuID} />
          )}
          {showObsoletePriceMsg && (<ObsoletePriceMsg />)}
        </div>
      </div>
    );
  }

  render() {
    const { optionsStore, labelsStore, card, extraClassName } = this.props;
    const isDisabled = card.isDisabled ? 'disabled' : '';
    const badgeStyles = { background: card.productBarColor };

    return (
      <div className={`cart-table__single indent-words ${card.pendingState} ${isDisabled} ${extraClassName}`}>

        <div className="my-card my-card--wrap">
          <div className="my-card__img-column">
            <a className="my-card__img" href={card.href}>
              <img src={getBSLImageURL(card.imgSrc, 113)} alt={card.imgAlt} className="my-card__img-src" />
            </a>
          </div>

          <div className="cart-table__column--wide">
            <div className="my-card__row">
              <a className="my-card__info cart-table__column" href={card.href}>
                {card.hasStatus && (<Badge style={badgeStyles}>{card.productBarText}</Badge>)}
                {card.isSubstitute && <Badge className="my-card__badge--replacing">{card.getReplacingBadgeTxt()}</Badge>}
                <div className="my-card__text">
                  <p className="my-card__title">{card.commRef}</p>
                  <PesEllipsis
                    maxHeight="48px"
                    content={createCardHtmlContent(card.commDesc)}
                  />
                </div>
                {!!card.elNumber && (
                  <p className="my-card__el-number">
                    <span>{card.elNumberLabel}</span>
                    <span>{card.elNumber}</span>
                  </p>
                )}
              </a>

              {this.renderIcons()}
            </div>
            {shouldRenderCustomizationFields(card) && (
              <CustomizationFields
                card={card}
                shouldRenderNotification={card.isClipboardNotify}
                showClipboardNotify={card.showClipboardNotify}
                customizationId={card.customizationId}
                productCr={card.productCr}
              />
            )}
            {this.hasPrice && (
              <div className="cart-table__column cart-table__column--max price cart-table--indent">
                <Subtotal item={card} measure={labelsStore.giftlistPricePeritem} />
              </div>
            )}

            {optionsStore.isDeliveryDisplay && (
              <div className="cart-table__column cart-table__column--max deliveryDate indent-words">
                <DeliveryCell item={card} />
              </div>
            )}
          </div>

          {this.renderFooter()}
        </div>
        {this.isShowSubstitutions && this.hasSubstitutions && (<SubstitutionSectionWrapper parent={card} />)}
      </div>
    );
  }
}

_SingleItemMobile.propTypes = {
  card: propTypes.shape({
    skuID: propTypes.string.isRequired,
    quantity: propTypes.oneOfType([propTypes.number, propTypes.string]),
    href: propTypes.string.isRequired,
    price: propTypes.number,
    deliveryTime: propTypes.string,
    currency: propTypes.string,
    commDesc: propTypes.string,
    imgAlt: propTypes.string,
    imgSrc: propTypes.string,
    remove: propTypes.func,
    changeQty: propTypes.func,
    setQty: propTypes.func,
    isInComparator: propTypes.bool,
    compareDisabled: propTypes.bool,
    handleCompareCLick: propTypes.func,
    elNumberLabel: propTypes.string,
    elNumber: propTypes.string,
    getProductChars: propTypes.func,
    getReplacingQtyMsg: propTypes.func.isRequired,
    getReplacingBadgeTxt: propTypes.func.isRequired,
    productBarText: propTypes.string.isRequired,
    productBarColor: propTypes.string.isRequired,
    isSubstitute: propTypes.bool.isRequired,
    isDisabled: propTypes.bool,
    isObsolete: propTypes.bool,
    isShowReplacingStatus: propTypes.bool,
    hasStatus: propTypes.string,
    pendingState: propTypes.string,
    commRef: propTypes.string,
    productCr: propTypes.string,
    customizationId: propTypes.string,
    isClipboardNotify: propTypes.bool,
    showClipboardNotify: propTypes.func,
    weeePricesData: propTypes.shape({
      weeePriceLabel: propTypes.string,
      weeePriceLabelMulti: propTypes.string,
      weeeLamp: propTypes.string,
      weeePackage: propTypes.string,
      weeePro: propTypes.string
    })
  }).isRequired,

  optionsStore: propTypes.shape({
    isPriceEnabledOnSite: propTypes.bool,
    isDeliveryDisplay: propTypes.bool,
    isWeeePricesVisible: propTypes.bool,
    disableSubstitutions: propTypes.bool
  }).isRequired,

  labelsStore: propTypes.shape({
    cardCompare: propTypes.string,
    removeLabel: propTypes.string,
    giftlistPricePeritem: propTypes.string,
    deliveryDaysHeadLabel: propTypes.string,
    daysLabel: propTypes.string,
    giftlistTableQty: propTypes.string
  }).isRequired,

  substRootStore: propTypes.shape({
    getSubstSectionStores: propTypes.func.isRequired,
    substitutions: propTypes.bool
  }).isRequired,

  isEditable: propTypes.bool,
  extraClassName: propTypes.string
};

_SingleItemMobile.defaultProps = {
  isEditable: true,
  extraClassName: ''
};

export const SingleItemMobile = inject('labelsStore', 'optionsStore', 'substRootStore')(observer(_SingleItemMobile));
